export const ArrowDownload = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 14.5a1 1 0 00-1 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4a1 1 0 10-2 0v4a3 3 0 003 3h14a3 3 0 003-3v-4a1 1 0 00-1-1zm-9.71 1.71a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.33-.21l4-4a1.004 1.004 0 10-1.42-1.42L13 13.09V3.5a1 1 0 00-2 0v9.59l-2.29-2.3a1.005 1.005 0 00-1.714.71 1.004 1.004 0 00.294.71l4 4z"
        fill="#C930FF"
      />
    </svg>
  )
}